"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _deprecate = require("@nerdwallet/deprecate");

var _contentContainerModule = _interopRequireDefault(require("./content-container.module.css"));

var _excluded = ["children", "className", "component"];

/**
 * @deprecated since version 1.2.4. Use <Box /> to implement layout.
 *
 * Wraps content with a container that sets a max-width, provides outside
 * gutters, and centers itself.
 */
var ContentContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ContentContainer, _React$Component);

  var _super = (0, _createSuper2.default)(ContentContainer);

  function ContentContainer() {
    (0, _classCallCheck2.default)(this, ContentContainer);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ContentContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _deprecate.printComponentDeprecationWarning)({
        component: 'ContentContainer',
        version: '1.2.4',
        migration: 'Use the <BoxContainer> component from @nerdwallet/react-box instead.'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          component = _this$props.component,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var Component = component || 'div';
      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, otherProps, {
        className: (0, _classnames.default)([className, _contentContainerModule.default['content-container']])
      }), children);
    }
  }]);
  return ContentContainer;
}(_react.default.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


ContentContainer.propTypes = {
  /* Content to wrap. */
  children: _propTypes.default.node,

  /* React component or HTML element to use instead of div. */
  // eslint-disable-next-line react/forbid-prop-types
  component: _propTypes.default.any,

  /* Class on container element. */
  className: _propTypes.default.string
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ContentContainer.defaultProps = {
  children: null,
  className: null,
  component: null
};
var _default = ContentContainer;
exports.default = _default;